import useSWR from 'swr';

import { fetcher } from '../index';
import type { IngestorRun, ProcessStatus } from '../../interfaces/lisa';

interface IngestorStatusResponse {
    recent: IngestorRun[];
    withSkipped: IngestorRun[];
    errors: IngestorRun[];
    process: ProcessStatus;
}

export default function useLisaIngestorStatus(refreshInterval = 0) {
    const { data, error, mutate } = useSWR<IngestorStatusResponse>(
        '/v1/dashboard/lisa/ingestor-status',
        fetcher,
        { refreshInterval }
    );

    return {
        recent: data?.recent ?? [],
        withSkipped: data?.withSkipped ?? [],
        errors: data?.errors ?? [],
        process: data?.process ?? null,
        isLoading: !data && !error,
        error,
        refresh: mutate,
    };
}
